export const CARGAR_MENU_CATEGORIAS="cargar_menu_categorias";
export const UPDATE_CATEGORIAS_MENU="update_categorias_menu";
export const MENU_PRINCIPAL="menu_principal";